<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Vehicle Status History</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        view and download vehicle status change history records over a time range
      </div>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>

      <span v-if="vehicle_tag_options && vehicle_tag_options.length > 0">
      &nbsp;&nbsp;&nbsp;Tag:
        &nbsp;<b-form-select v-model="selected_tag" :options="vehicle_tag_options" style="font-size: 20px; font-weight: bold; width:180px"/>
      </span>

      &nbsp;&nbsp;&nbsp;Status:
        &nbsp;<b-form-select v-model="selected_status" :options="status_options" style="font-size: 20px; font-weight: bold; width:180px"/>

      &nbsp;&nbsp;&nbsp;Vehicle:
        &nbsp;<b-form-select v-model="selected_vehicle" :options="vehicle_options" style="font-size: 20px; font-weight: bold; width:150px"/>

      &nbsp;&nbsp;&nbsp;<b-form-input style="font-size: 20px; font-weight: bold; width: 185px" v-model="search_filter" placeholder="filter by keyword"/>

      &nbsp;&nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;&nbsp;<b-button v-on:click.prevent="download()">Download</b-button>
      &nbsp;&nbsp;&nbsp;<span v-if="summary" class="col total" style="float:right; max-width: 150px; border: 1px solid grey;">{{items.length }} of {{summary.total_cnt}}</span>
    </div>

<!--    <div v-if="summary">-->
<!--      <div class="row" style="margin: -10px 0px 20px 0px; font-weight: bold; font-size: 20px;">-->
<!--        <div class="col total" style="max-width: 250px; border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>-->
<!--        <div class="col" style="float:right; border: none"><b-form-input style="font-size: 20px; font-weight: bold; width: 185px" v-model="search_filter" placeholder="filter by keyword"/></div>-->
<!--      </div>-->
<!--    </div>-->

    <div v-if="summary">
      <b-table :busy="loading" :sticky-header="windowHeight ? windowHeight*.9 + 'px':'80vh'" bordered :items="items" :fields="visibleFields"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="notes" slot-scope="row">
          <div style="text-align: left">{{row.item.notes}}</div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>
        <template slot="last_dirty_time" slot-scope="row">
          {{row.item.last_dirty_time | formatDateTimeSmall}}
        </template>
        <template slot="last_cleaned_time" slot-scope="row">
          {{row.item.last_cleaned_time | formatDateTimeSmall}}
        </template>
        <template slot="last_washed_time" slot-scope="row">
          {{row.item.last_washed_time | formatDateTimeSmall}}
        </template>
        <template slot="last_ready_time" slot-scope="row">
          {{row.item.last_ready_time | formatDateTimeSmall}}
        </template>
        <template slot="detailed_date" slot-scope="row">
          {{row.item.detailed_date | formatDateTimeSmall}}
        </template>
        <template slot="wrapped_date" slot-scope="row">
          {{row.item.wrapped_date | formatDateTimeSmall}}
        </template>
        <template slot="dump_date" slot-scope="row">
          {{row.item.dump_date | formatDateTimeSmall}}
        </template>
        <template slot="last_out_time" slot-scope="row">
          {{row.item.last_out_time | formatDateTimeSmall}}
        </template>
        <template slot="last_returned_time" slot-scope="row">
          {{row.item.last_returned_time | formatDateTimeSmall}}
        </template>

      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {api_url, get_tag_list, get_vehicle_list, get_vehicle_status_history} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";

export default {
  name: 'vehicle_status_history',
  components: {
     datetime
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      details_fromDate: justDate(moment().add(-1, 'days')),
      details_toDate: justDate(moment()),
      selected_tag: '',
      selected_vehicle: '',
      selected_status:'',
      search_filter: '',
      vehicle_options: [ { value: '', text: 'All' }],
      updating: false,
      items: [],
      items_full: [],
      summary: null,
      loading: false,
      vehicle_tag_options: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      status_options: [
        { value: '', text: 'All' },
        { value: 'READY', text: 'READY' },
        { value: 'DIRTY', text: 'DIRTY' },
        { value: 'CLEAN', text: 'CLEAN' },
        { value: 'WASH', text: 'WASHED' },
        { value: 'OUT', text: 'OUT' },
      ],
      fields: [
        { key: 'vehicle_name', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "110px" }},
        { key: 'processed_time', label:'Update At', visible: true, sortable: true, thStyle: { width: "140px" }},
        { key: 'updated_by', label:'Updated By', visible: true, sortable: true, thStyle: { width: "140px" }},
        { key: 'vehicle_status', label:'Veh Status', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'maintenance_status', label:'Maint Status', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'booking_hash', label:'Booking', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'last_dirty_time', label:'Dirty', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_time', label:'Cleaned', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'last_washed_time', label:'Washed', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_washed_number', label:'Washed #', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'last_ready_time', label:'Ready', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_returned_time', label: 'Last Return', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'dump_date', label:'Dump Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'detailed_date', label:'Detail Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'wrapped_date', label:'Wrapped Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'odometer', label:'Odometer', visible: false, sortable: true, thStyle: { width: "100px" }},
        { key: 'fuel_level', label:'Fuel', visible: false, sortable: true, thStyle: { width: "100px" }},
        { key: 'def_level', label:'DEF', visible: false, sortable: true, thStyle: { width: "100px" }},
        { key: 'wheelchair', label: 'WC', sortable: true, thStyle: { width: "75px" }},
        { key: 'stayanddo', label: 'S&D', sortable: true, thStyle: { width: "75px" }},
        { key: 'tote', label: 'Tote', sortable: true, thStyle: { width: "110px" }},
        { key: 'notes', label: 'Notes', sortable: true, visible: true, thStyle: { width: "220px" }},
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      }
    }
  },
  async created() {
    this.fields_all = this.fields
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async check_features() {
      this.items = []
      this.summary = null
      this.load_tags()
      this.load_vehicles()
    },
    async load_vehicles() {
      const {value: {data = []}} = await get_vehicle_list(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.vehicle_options = data
    },
    async load_tags() {
      const {value: {data = []}} = await get_tag_list(this.user.tenant)
      this.vehicle_tag_options = data
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      return false;
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_vehicle_status_history(this.user.tenant, this.selected_tag, this.selected_vehicle, this.search_filter, this.selected_status, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/vehiclestatus/history/download`,
          {
            tenant: this.user.tenant,
            tagName: this.selected_tag,
            vehicleName: this.selected_vehicle,
            filter: this.search_filter,
            statusFilter: this.selected_status,
            startDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            endDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `vsm-history-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
    filter_items() {
      this.items = this.items_full
      if (this.search_filter != '') {
        this.items = this.items.filter(item => (this.contains(item.vehicle_name, this.search_filter) || this.contains(item.updated_by, this.search_filter) || this.contains(item.vehicle_status, this.search_filter) || this.contains(item.notes, this.search_filter)))
      }
    },
    contains(val1, val2) {
      if (val1 != null && val2 != null) {
        return String(val1).toLowerCase().indexOf(String(val2).toLowerCase()) != -1;
      }
      return false;
    },

},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_history_fields)
        custom_fields = this.summary.visible_history_fields;

      if (custom_fields != null) {
        custom_fields = "vehicle_name," + custom_fields;
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_tag() {
      if (this.selected_tag != '')
        this.selected_vehicle = ''
    },
    selected_vehicle() {
      if (this.selected_vehicle != '')
        this.selected_tag = ''
    },
    search_filter() {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate
    }
  }
}
</script>

<style scoped>

</style>

